/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-08-039 03:16:54 AM
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { ChoiceList } from '@shopify/polaris';

export class RenderCheckbox2 extends Component<Props> {
  render() {
    const { label, options, name, meta = {}, anotherProps, input } = this.props;
    return (
      <div>
        <ChoiceList
          id={name}
          allowMultiple
          title={label}
          choices={options}
          selected={input.value}
          onChange={input.onChange}
          error={!!meta.error && !!meta.touched ? meta.error : ''}
          {...anotherProps}
        />
      </div>
    );
  }
}
